import {
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Warning as WarningIcon,
  Archive as ArchiveIcon
} from '@mui/icons-material'
import { Box, Button } from '@mui/material'

import { SmartPayProcessingResult } from 'types'

import { ProcessingSummary } from './ProcessingSummary'
import { RecordList } from './RecordList'

interface ProcessingResultsProps {
  result: SmartPayProcessingResult
  onDownloadCsv: () => void
  onProcessAnother: () => void
}

export const ProcessingResults = ({
  result,
  onDownloadCsv,
  onProcessAnother,
}: ProcessingResultsProps) => {
  return (
    <Box>
      <ProcessingSummary result={result} />

      <RecordList
        records={result.matchedSuccessfully}
        title='Successfully Matched (Status: Archived)'
        icon={<CheckCircleIcon color='success' />}
        color='#4caf50'
      />

      <RecordList
        records={result.mismatched}
        title='Mismatched Records (Status: Flagged)'
        icon={<WarningIcon color='warning' />}
        color='#ff9800'
      />

      <RecordList
        records={result.matchedInArchived}
        title='Matched in Archived (Already Processed)'
        icon={<ArchiveIcon color='info' />}
        color='#2196f3'
      />

      <RecordList
        records={result.notFound}
        title='Not Found in System'
        icon={<ErrorIcon color='error' />}
        color='#f44336'
      />

      <RecordList
        records={result.validationErrors}
        title='Validation Errors'
        icon={<ErrorIcon color='error' />}
        color='#d32f2f'
      />

      {result.outputCsv && (
        <Box sx={{ mt: 3 }}>
          <Button variant='outlined' onClick={onDownloadCsv} fullWidth>
            Download Processing Results CSV
          </Button>
        </Box>
      )}

      <Button variant='outlined' onClick={onProcessAnother} sx={{ mt: 2 }} fullWidth>
        Process Another File
      </Button>
    </Box>
  )
}
